const C = [], n = {
  Banner: ["CPM", "CPA", "DCPM"],
  Popunder: ["CPM", "CPA", "DCPM"],
  Interstitial: ["CPM", "CPA", "DCPM"],
  Native: ["CPM", "CPA", "DCPM", "MXDCPM"],
  Link: ["CPM", "CPA", "DCPM"],
  Video: ["CPM", "CPA", "DCPM", "CPV"],
  VideoSlider: ["CPM", "CPA", "DCPM", "CPV"],
  OutstreamVideo: ["CPM", "CPA", "DCPM", "CPV"]
}, i = (P) => P in n, o = (P) => !P || !i(P) ? C : n[P], r = (P, e) => o(P).includes(e), M = (P) => {
  const e = o(P);
  return e.length > 0 ? e.join(", ") : "none";
};
export {
  M as formatAllowedPricingModelsForAdType,
  o as getAllowedPricingModelsForAdType,
  r as isPricingModelAllowedForAdType,
  n as pricingModelsByAdType
};
//# sourceMappingURL=pricing-model-policy.js.map
